import axios from 'axios';
import queryString from 'query-string';
import { forEach } from 'lodash';
import { store } from 'redux/store';


function getToken(headers) {
    const { layout } = store.getState();
    const { userToken } = layout;

    if (userToken.data === null) {
        return {
            ...headers,
        };
    }
    return {
        Authorization: `${userToken.data.token_type} ${userToken.data.access_token}`,
        ...headers,
    };
}

/**
 * Return Axios of method GET
 * @param {string} url Url of ajax
 * @param {object} data Params of ajax
 * @author Zakaria Louardi
 */
/* export function get(url, data, headers) {
    return fetch(`${url}?${queryString.stringify(data)}`, {
        method: 'GET',
        headers: getToken(headers || { 'Content-Type': 'application/json' }),,
        mode: 'cors',
    });
} */
export function get(url, data = {}, headers = null) {
    return axios({
        url: `${url}?${queryString.stringify(data)}`,
        method: 'get',
        headers: getToken(headers || { 'Content-Type': 'application/json' }),
    });
}

/**
 * Return Fetch of method POST
 * @param {string} url Url of ajax
 * @param {object} data Params of ajax
 * @author Youssef Lahssini
 */
export function post(url, data, headers, mode = 'cors') {
    return fetch(url, {
        method: 'POST',
        headers: getToken(headers || { 'Content-Type': 'application/json' }),
        mode,
        body: JSON.stringify(data),
    });
}

/**
 * Return Fetch of method PUT
 * @param {string} url Url of ajax
 * @param {object} data Params of ajax
 * @author Youssef Lahssini
 */
export function put(url, data, headers) {
    return fetch(url, {
        method: 'PUT',
        headers: getToken(headers || { 'Content-Type': 'application/json' }),
        mode: 'cors',
        body: JSON.stringify(data),
    });
}

/**
 * Return Fetch of method DELETE
 * @param {string} url Url of ajax
 * @param {object} data Params of ajax
 * @author Youssef Lahssini
 */
export function del(url, data, headers) {
    return fetch(url, {
        method: 'DELETE',
        headers: getToken(headers || { 'Content-Type': 'application/json' }),
        mode: 'cors',
        body: JSON.stringify(data),
    });
}

/**
 * Return Fetch of method POST
 * @param {string} url Url of ajax
 * @param {object} data Params of ajax
 * @author Zakaria Louardi
 */
export function postForm(url, data, headers) {
    return fetch(url, {
        method: 'POST',
        headers: getToken(headers),
        mode: 'cors',
        body: data,
    });
}

/**
 * Return Fetch of method POST
 * @param {string} url Url of ajax
 * @param {object} data Params of ajax
 * @author Zakaria Louardi
 */
export function putForm(url, data, headers) {
    return fetch(url, {
        method: 'PUT',
        headers: getToken(headers),
        mode: 'cors',
        body: data,
    });
}

/**
 * Return Fetch of method POST, it send data in FormDATA with credentials include
 * @param {string} method Method of ajax (post | put)
 * @param {string} url Url of ajax
 * @param {object} data Params of ajax
 * @author Youssef Lahssini
 */
export function postFormData(url, data, headers) {
    const formData = new FormData();

    forEach(data, (value, key) => {
        formData.append(key, value);
    });

    return fetch(url, {
        method: 'POST',
        mode: 'cors',
        body: formData,
        headers: getToken(headers),
    });
}
